
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stable/baseline",
      function () {
        return require("private-next-pages/stable/baseline.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stable/baseline"])
      });
    }
  